<!-- @format -->
<template>
    <div v-if="optionInterests.length" class="columns">
        <div class="column is-8">
            <field name="data.interest" :errors="errors">
                <label class="label">I am interested in</label>
                <p v-for="option in optionInterests" :key="option.id" class="control">
                    <label class="checkbox">
                        <input v-model="interest" type="checkbox" :value="option.id" />&nbsp;{{ option.text }}
                    </label>
                </p>
            </field>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        errors: {
            type: [Array, Object],
            default: () => []
        },
        formData: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            interest: [],
            optionInterests: []
        };
    },

    computed: {
        ...mapGetters({
            mainPublicationName: 'publication/mainPublicationName'
        })
    },

    watch: {
        interest() {
            this.updateFormData();
        },
        formData() {
            this.interest = this.formData && this.formData.interest ? this.formData.interest : null;
        },
        deep: true
    },

    mounted() {
        this.optionInterests.push(
            {
                id: 'publishing',
                text: 'Publishing on ' + this.mainPublicationName
            },
            {
                id: 'advertising',
                text: 'Advertising on ' + this.mainPublicationName
            },
            {
                id: 'working',
                text: 'Working at ' + this.mainPublicationName
            },
            {
                id: 'other',
                text: 'Other'
            }
        );
        this.updateFormData(); // Init
    },

    methods: {
        /**
         * Update form data for parent
         */
        updateFormData() {
            this.$emit('update:formData', {
                interest: this.interest
            });
        }
    }
};
</script>
